<script>
export default {
  inject: ['$_', '$axios'],
  emits: ["dropZone2Emissions", "uploadInProgress"],
  name: "dropZone2Component",
  props: {
    fileIdentifier: String,
    formName: String,
    zoneTitle: String,
    dataTs: String,
    acceptedFiles: String,
    imageDataObj: Object,
    inputsDisabled: Boolean
  },
  data() {
    return {
      showProgress: false,
      progressValue: 0,
      fileUploaded: false,
      imageData: '',
      imageMetaData: {timestamp: '', location: ''}
    }
  },
  components: {},
  methods: {
    newFileAdded() {
      let vm = this;
      let data = new FormData();
      data.append(vm.fileIdentifier, vm.$refs[vm.fileIdentifier].files[0]);
      data.append('fileType', vm.$refs[vm.fileIdentifier].files[0].type);
      let config = {
        onUploadProgress: function (progressEvent) {
          vm.progressValue = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          vm.$emit('uploadInProgress', {progressValue: vm.progressValue, uploadDone: vm.progressValue === 100});
        }
      };
      vm.showProgress = true;
      vm.$axios.post(`/profile/mediaUploading/${vm.fileIdentifier}/${vm.dataTs}/add/${vm.formName}`, data, config)
          .then(function (res) {
            if (res.data.success) {
              vm.loadFileImages();
              switch (vm.fileIdentifier) {
                case 'partnerInvoiceFile':
                  vm.$emit('dropZone2Emissions', {
                    action: 'imageAdded',
                    fileIdentifier: vm.fileIdentifier,
                    fileDetails: res.data.fileData
                  });
                  break;
                case 'signedAmhInvoiceFile':
                  vm.$emit('dropZone2Emissions', {
                    action: 'imageAdded',
                    fileIdentifier: vm.fileIdentifier,
                    fileDetails: res.data.fileData
                  });
                  break;
                case 'amhRemittanceFile':
                  vm.$emit('dropZone2Emissions', {
                    action: 'imageAdded',
                    fileIdentifier: vm.fileIdentifier,
                    fileDetails: res.data.fileData
                  });
                  break;
                case 'partnerReceiptFile':
                  vm.$emit('dropZone2Emissions', {
                    action: 'imageAdded',
                    fileIdentifier: vm.fileIdentifier,
                    fileDetails: res.data.fileData
                  });
                  break;
                default:
                  vm.$emit('dropZone2Emissions', {action: 'imageAdded', fileIdentifier: vm.fileIdentifier});
                  break;
              }


            }
          })
          .catch(function (err) {
            console.error(err);
            vm.showProgress = false;
          });
    },
    fileRemoved() {
      let vm = this;
      let data = new FormData();
      vm.showProgress = true;
      vm.$axios.post(`/profile/mediaUploading/${vm.fileIdentifier}/${vm.dataTs}/remove/${vm.formName}`, data)
          .then(function (res) {
            if (res.data.success) {
              vm.showProgress = false;
              vm.loadFileImages();
              switch (vm.fileIdentifier) {
                case 'partnerInvoiceFile':
                  vm.$emit('dropZone2Emissions', {
                    action: 'imageRemoved',
                    fileIdentifier: vm.fileIdentifier,
                    fileDetails: res.data.fileData
                  });
                  break;
                default:
                  vm.$emit('dropZone2Emissions', {action: 'imageRemoved', fileIdentifier: vm.fileIdentifier});
                  break;
              }

            }
          })
          .catch(function (err) {
            console.error(err);
            vm.showProgress = false;
          });
    },
    dropZoneDragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-light-gray')) {
        event.currentTarget.classList.remove('bg-light-gray');
        event.currentTarget.classList.add('bg-dark-gray');
      }
    },
    dropZoneDragleave(event) {
      event.preventDefault();
      event.currentTarget.classList.add('bg-light-gray');
      event.currentTarget.classList.remove('bg-dark-gray');
    },
    fileDrop(event) {
      event.preventDefault();
      let vm = this;
      this.$refs[vm.fileIdentifier].files = event.dataTransfer.files;
      this.newFileAdded();
      event.currentTarget.classList.add('bg-light-gray');
      event.currentTarget.classList.remove('bg-dark-gray');
    },
    loadFileImages() {
    }
  },
  computed: {},
  mounted() {
    let vm = this;

    if (typeof vm.imageDataObj.thumbnail !== 'undefined') {
      vm.fileUploaded = true;
      vm.imageData = vm.imageDataObj.thumbnail;
      if (typeof vm.imageDataObj.location !== 'undefined') {
        vm.imageMetaData.location = vm.imageDataObj.location;
      }
      if (typeof vm.imageDataObj.timestamp !== 'undefined') {
        vm.imageMetaData.timestamp = vm.imageDataObj.timestamp;
      }
    } else {
      vm.fileUploaded = false;
      vm.imageData = '';
    }


  },
  watch: {
    dataTs: {
      handler(newValue) {
        let vm = this;
        if (vm.$_.trim(newValue) !== '') {
          vm.loadFileImages();
        }
      },
      deep: true
    },
    imageDataObj: {
      handler(newValue) {
        let vm = this;
        if (typeof newValue.thumbnail !== 'undefined') {
          vm.fileUploaded = true;
          vm.imageData = newValue.thumbnail;
          if (typeof newValue.location !== 'undefined') {
            vm.imageMetaData.location = newValue.location;
          }
          if (typeof newValue.timestamp !== 'undefined') {
            vm.imageMetaData.timestamp = newValue.timestamp;
          }
        } else {
          vm.fileUploaded = false;
          vm.imageData = '';
        }

      },
      deep: true
    }
  }
}
</script>

<template>
  <div class="drop-zone2-container">
    <div class="drop-zone2-title">{{ zoneTitle }}</div>
    <div class="drop-zone2-highlight bg-light-gray" @dragover="dropZoneDragover($event)"
         @dragleave="dropZoneDragleave($event)" @drop="fileDrop($event)" v-if="!fileUploaded">
      <input type="file" v-bind:name="fileIdentifier" v-bind:id="fileIdentifier"
             class="drop-zone2-input"
             @change="newFileAdded()"
             v-bind:ref="fileIdentifier"/>
      <div class="drop-zone2-plus">
        <progress class="progress is-success" v-bind:value="progressValue" max="100"
                  v-if="progressValue!==0 && showProgress">{{ progressValue }}%
        </progress>
        <progress class="progress is-success" max="100" v-if="progressValue===0 && showProgress">uploading</progress>
        <div v-if="!showProgress">+</div>
      </div>
    </div>
    <div v-else>
      <img v-bind:src="imageData">
      <div>Timestamp: <span>{{ imageMetaData.timestamp }}</span></div>
      <div>Location:
        <a v-bind:href="imageMetaData.location" target="_blank" v-if="imageMetaData.location!==''">Here</a>
        <span v-else></span>
      </div>
      <button class="button is-fullwidth" v-on:click="fileRemoved" v-bind:disabled="inputsDisabled">Remove</button>
    </div>
  </div>
</template>

<style scoped>

.drop-zone2-container {
  position: relative;
}

.drop-zone2-highlight {
  height: 200px;
  padding: 10px;
  position: relative;
  border-radius: 10px;
}


.drop-zone2-input {
  opacity: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.drop-zone2-plus {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.bg-light-gray {
  background: lightgray;
}

.bg-dark-gray {
  background: darkgray;
}
</style>